<template>
  <div class="container mt-3">
    <div class="flex justify-between">
      <div v-if="user">
        <div class="flex items-center space-x-3">
          <div>
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.58 11.4709C15.0345 10.9028 15.2846 10.1984 15.29 9.4709C15.29 8.59834 14.9434 7.76151 14.3264 7.14452C13.7094 6.52752 12.8726 6.1809 12 6.1809C11.1274 6.1809 10.2906 6.52752 9.67362 7.14452C9.05662 7.76151 8.71 8.59834 8.71 9.4709C8.71542 10.1984 8.96551 10.9028 9.42 11.4709C8.52863 12.0133 7.8293 12.8211 7.42 13.7809C7.36271 13.9027 7.3306 14.0348 7.32558 14.1693C7.32056 14.3037 7.34274 14.4379 7.39079 14.5636C7.43884 14.6893 7.51177 14.804 7.60521 14.9009C7.69865 14.9977 7.81068 15.0747 7.93459 15.1272C8.0585 15.1798 8.19174 15.2067 8.32632 15.2066C8.4609 15.2064 8.59406 15.179 8.71782 15.1261C8.84157 15.0732 8.95338 14.9959 9.04655 14.8988C9.13971 14.8017 9.21231 14.6867 9.26 14.5609C9.48983 14.0236 9.87157 13.5652 10.3583 13.2419C10.8451 12.9186 11.4157 12.7444 12 12.7409C12.586 12.7425 13.1588 12.9157 13.6475 13.2392C14.1362 13.5626 14.5195 14.0221 14.75 14.5609C14.8266 14.7416 14.9546 14.8959 15.1182 15.0043C15.2818 15.1128 15.4737 15.1707 15.67 15.1709C15.8038 15.1684 15.936 15.1413 16.06 15.0909C16.3039 14.9873 16.4966 14.7912 16.596 14.5455C16.6954 14.2999 16.6932 14.0249 16.59 13.7809C16.1781 12.8196 15.4751 12.0117 14.58 11.4709ZM12 10.7409C11.7444 10.7409 11.4946 10.665 11.2823 10.5228C11.0699 10.3806 10.9046 10.1785 10.8073 9.94222C10.7099 9.70592 10.685 9.44604 10.7356 9.19553C10.7862 8.94503 10.91 8.71519 11.0914 8.53519C11.2728 8.35518 11.5036 8.23312 11.7545 8.18448C12.0054 8.13584 12.2651 8.16282 12.5006 8.26199C12.7362 8.36116 12.9369 8.52806 13.0775 8.74151C13.218 8.95496 13.292 9.20534 13.29 9.4609C13.2874 9.80129 13.1503 10.1268 12.9087 10.3666C12.667 10.6064 12.3404 10.7409 12 10.7409ZM18 2.1709H6C5.20435 2.1709 4.44129 2.48697 3.87868 3.04958C3.31607 3.61219 3 4.37525 3 5.1709V16.1709C3 16.9665 3.31607 17.7296 3.87868 18.2922C4.44129 18.8548 5.20435 19.1709 6 19.1709H8.59L11.29 21.8809C11.3834 21.9736 11.4943 22.0469 11.6161 22.0967C11.7379 22.1464 11.8684 22.1717 12 22.1709C12.2383 22.1709 12.4689 22.0858 12.65 21.9309L15.87 19.1709H18C18.7956 19.1709 19.5587 18.8548 20.1213 18.2922C20.6839 17.7296 21 16.9665 21 16.1709V5.1709C21 4.37525 20.6839 3.61219 20.1213 3.04958C19.5587 2.48697 18.7956 2.1709 18 2.1709ZM19 16.1709C19 16.4361 18.8946 16.6905 18.7071 16.878C18.5196 17.0655 18.2652 17.1709 18 17.1709H15.5C15.2617 17.1709 15.0311 17.256 14.85 17.4109L12.05 19.8109L9.71 17.4609C9.61656 17.3682 9.50574 17.2949 9.38391 17.2451C9.26207 17.1954 9.13161 17.1701 9 17.1709H6C5.73478 17.1709 5.48043 17.0655 5.29289 16.878C5.10536 16.6905 5 16.4361 5 16.1709V5.1709C5 4.90568 5.10536 4.65133 5.29289 4.46379C5.48043 4.27626 5.73478 4.1709 6 4.1709H18C18.2652 4.1709 18.5196 4.27626 18.7071 4.46379C18.8946 4.65133 19 4.90568 19 5.1709V16.1709Z"
                fill="#20419B"
              />
            </svg>
          </div>
          <div class="fs-22 fw-500">{{user.name}}</div>
          <span v-if="isImgPackage"><img
              class="h-9"
              :src="getUrlImg(isImgPackage)"
              alt=""
            /></span>
          <div
            v-else-if="isPendingOrder"
            class="bg-pending-order"
          > Đang chờ xác nhận </div>
        </div>
      </div>
      <div
        class="flex justify-end items-center"
        v-show="!modeView"
      >
        <div class="text-right">
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            @click="goToBack"
            class="cursor-pointer"
          >
            <path
              d="M6 18.4998L17.9998 6.5"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17.9998 18.4998L6 6.5"
              stroke="#292D32"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
    <div
      class="row mt-3"
      v-if="disease"
    >
      <div
        v-show="!modeView"
        class="col-md-6"
      >
        <p class="fs-28 fw-500 txt-black mb-3">Chi tiết Hồ Sơ Sức Khỏe</p>

        <div class="d-flex align-items-center mb-3 pt-2">
          <div class="circle-num text-center fs-18 fw-500 txt-black me-2">1</div>
          <p class="mb-0 fs-18 fw-500 txt-black"> Thông tin sức khỏe</p>
        </div>
        <div
          class="mb-3"
          v-if="disease.person"
        >
          <label class="fs-16 fw-500 txt-black">Tạo Hồ Sơ Sức Khỏe cho <span class="text-danger">*</span></label>
          <div
            class="ml-3"
            v-html="disease.person.name"
          ></div>

        </div>
        <!-- * -->
        <div class="mb-3">
          <label class="fs-16 fw-500 txt-black">Chẩn đoán <span class="text-danger">*</span></label>
          <div
            class="ml-3"
            v-html="disease.diseases_name"
          ></div>
        </div>
        <!-- * -->
        <div class="mb-3">
          <label class="fs-16 fw-500 txt-black">Giai đoạn</label>
          <div
            class="ml-3"
            v-html="disease.diseases_stage"
          ></div>
        </div>
        <!-- * -->
        <div class="mb-3">
          <label class="fs-16 fw-500 txt-black">Tình trạng hiện tại</label>
          <div
            class="ml-3"
            v-html="disease.diseases_current_cure"
          ></div>
        </div>
        <!-- * -->
        <div class="mb-3">
          <label class="fs-16 fw-500 txt-black">Điều trị</label>
          <div
            class="ml-3"
            v-html="disease.diseases_previous_cure"
          ></div>
        </div>
        <!-- * -->
        <div class="mb-4">
          <label class="fs-16 fw-500 txt-black">Bệnh khác</label>
          <div
            class="ml-3"
            v-html="disease.background_diseases"
          ></div>
        </div>
        <!-- *****2***** -->
        <div class="d-flex align-items-center mb-3 pt-2">
          <div class="circle-num text-center fs-18 fw-500 txt-black me-2">2</div>
          <p class="mb-0 fs-18 fw-500 txt-black"> Người liên hệ</p>
        </div>
        <!-- * -->
        <div class="mb-3">
          <label class="fs-16 fw-500 txt-black">Họ và tên</label>
          <div
            class="ml-3"
            v-html="disease.contact_name"
          ></div>
        </div>
        <!-- * -->
        <div class="mb-3">
          <label class="fs-16 fw-500 txt-black">Số điện thoại</label>
          <div
            class="ml-3"
            v-html="disease.contact_phone"
          ></div>
        </div>
        <!-- * -->
        <div class="mb-4">
          <label class="fs-16 fw-500 txt-black">Mối quan hệ ( Với bạn )</label>
          <div
            class="ml-3"
            v-html="disease.contact_relationship"
          ></div>
        </div>
      </div>
      <div :class="modeView ? 'col-12' : 'col-md-6'">
        <DiseaseDocument @switchModeView="handleModeView" />
      </div>
    </div>

    <div
      class="py-3 flex justify-center items-center space-x-5"
      v-show="!modeView"
    >
      <button
        class="btn btn-pri w-40 radius-15"
        @click="goToEdit()"
        :disabled="loading"
      >Chỉnh sửa
        <span
          v-if="loading"
          class="spinner-border ms-2"
          role="status"
        >
          <span class="visually-hidden">Loading...</span>
        </span>
      </button>
      <button
        class="btn btn-pri w-40 radius-15"
        @click="nextStep()"
        :disabled="loading"
      >Mời Bác sĩ
        <span
          v-if="loading"
          class="spinner-border ms-2"
          role="status"
        >
          <span class="visually-hidden">Loading...</span>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import appUtils from '../../utils/appUtils'
import DiseaseDocument from './DiseaseDocument.vue'

export default {
  name: 'DiseasesView',
  components: { DiseaseDocument },
  data () {
    return {
      disease: null,
      user: null,
      loading: false,
      modeView: false
    }
  },
  mounted () {
    this.getUserInfo()
    this.getPersonDisease()
    this.user = this.$user
  },
  computed: {
    isImgPackage () {
      const redeem = this.user?.redeem_package
      if (redeem) {
        return redeem.package_icon
      }
      const packages = this.user?.user_packages || []
      let result = packages?.find(item => {
        return item.member_package?.code.toUpperCase() === 'HODO GOLD' || item.member_package?.code.toUpperCase() === 'HODO GOLD PLUS'
      })
      if (!result) {
        result = packages?.find(item => {
          return item.member_package?.code.toUpperCase() === 'HODO SILVER PLUS'
        })
      }
      return result && result.member_package?.package_icon
    },
    isPendingOrder () {
      return this.user?.is_pending_order
    }
  },
  methods: {
    nextStep () {
      this.$router.push({ path: `/hssk/${this.$route.params.pdid}/moi-bac-si` })
    },
    async getPersonDisease () {
      const self = this
      await self.$rf.getRequest('AuthRequest').getDisease(self.$route.params.pdid, false).then((r) => {
        self.disease = r.data
      }).catch((e) => {
        console.log(e)
        window.$toast.open({
          message: 'Bạn không có quyền xem hồ sơ này hoặc đã có lỗi xảy ra',
          type: 'error'
        })
      })
    },
    async getUserInfo () {
      const self = this
      await self.$rf.getRequest('AuthRequest').me().then((rs) => {
        appUtils.setLocalUser(rs.data)
      }).catch((e) => {
        console.log(e)
      })
    },
    getUrlImg (path) {
      return appUtils.getDocumentURL(path)
    },
    goToBack () {
      this.$router.push({ name: 'ListDiseases' })
    },
    goToEdit () {
      this.$router.push({ path: `/hssk/${this.$route.params.pdid}/cap-nhat` })
    },
    handleModeView (show) {
      this.modeView = show
    }
  }
}
</script>

<style scoped>
.btn {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0.10000000149011612px;
  text-align: center;
}
.form-control,
.form-select {
  border-top: 0;
  border-left: 0;
  border-right: 0;
  border-radius: 0;
  color: #476dd6;
}
.t-red {
  color: #de3854;
}
.file-wraper {
  width: 100%;
  height: 99px;
  border-radius: 8px;
  background-color: #f7f9fb;
  cursor: pointer;
}
.circle-num {
  width: 24px !important;
  height: 24px !important;
  min-width: 24px !important;
  min-height: 24px !important;
  background-color: #f3f3f4;
  border-radius: 12px;
}

.bg-pending-order {
  background: #ffbc99;
  border-radius: 16px;
  padding: 0 12px;
  color: black;
  font-size: 14px;
  font-weight: 500;
}
</style>
